import React, { useState, useEffect } from 'react';
//import Bag from '../Bag/Bag';
import Header from '../Header';
import Footer from '../Footer';
import { v4 as uuidv4 } from 'uuid';
import '../styles/productPage.scss';

import { useNavigate } from 'react-router-dom';

//import { useDispatch } from 'react-redux';

function ProductPage({
    image1,
    image2,
    image3,
    image4,
    image5,
    productName,
    productPrice,
    productInfo,
    size,
    link,
}) {
    // const dispatch = useDispatch();
    //const addItem = (product) => {
    //    dispatch({ type: 'ADD_ITEM', payload: product });
    // };

    const [activeDetail, setActiveDetail] = useState(1);
    const [activeElement, setActiveElement] = useState(1);
    const [itemQuantity, setItemQuantity] = useState(0);
    const [itemSize, setItemSize] = useState('');
    const [activeImg, setActiveImg] = useState(image1);
    const liElements = [
        { id: 1, text: 'Info' },
        { id: 2, text: 'Size Guide' },
        { id: 3, text: 'Details' },
        { id: 4, text: 'Delivery' },
    ];

    function handleQuantityChange(e) {
        setItemQuantity(e.target.value);
    }

    function addProductToBag({ name, price, link, photo }) {
        console.log('ilość: ' + itemQuantity);
        console.log(itemSize);
        console.log('nazwa: ' + name);
        console.log('cena: ' + price);

        if (itemQuantity !== 0 && itemSize !== '') {
            // addItem - dodawanie przez reducer do store'a
            // addItem({
            //    name: name,
            //     id: uuidv4() /*id: itemQuantity + name + itemSize*/,
            //      size: itemSize,
            //      quantity: itemQuantity,
            //       price: itemQuantity * price,
            //      link: link,
            //    photo: photo,
            // });
            setItemQuantity(0);
            setItemSize('');
            //setItemPrice(0);
            //setItemName('');
            size === 'One' && resetSizeInputOnSize();
        } else {
            return;
        }
    }

    const navigate = useNavigate();
    useEffect(() => {
        setActiveImg(image1);
    }, [navigate, image1]);

    function resetSizeInputs() {
        const sizeInputs = document.querySelectorAll('.size');
        sizeInputs.forEach((item) => {
            item.checked = false;
        });
        console.log(sizeInputs);
        //document.querySelectorAll('.size').checked = false;
    }

    function resetSizeInputOnSize() {
        if (document.getElementById('oneSize').checked) {
            const oneSizeInput = document.querySelector('#oneSize');
            oneSizeInput.checked = false;
        }
    }

    let SELECT_SIZE = <p>Size</p>;

    SELECT_SIZE = (
        <label htmlFor='oneSize'>
            <input
                className='size'
                type='radio'
                name='size'
                id='oneSize'
                onClick={() => setItemSize('One')}
            />
            <span className='one__size'>One</span>
        </label>
    );

    return (
        <>
            <Header />
            {/* <Bag /> */}

            <div className='product__container'>
                <div className='product'>
                    <div className='img-container-mobile'>
                        <img
                            id='imageBox'
                            src={process.env.PUBLIC_URL + `${activeImg}`}
                            alt='Product'
                        />
                    </div>

                    <div className='product-small-img'>
                        <img
                            src={process.env.PUBLIC_URL + `${image1}`}
                            alt='product photo_1'
                            onClick={() => setActiveImg(image1)}
                        />
                        {image2 && (
                            <img
                                src={image2}
                                alt='product photo_3'
                                onClick={() => setActiveImg(image2)}
                            />
                        )}
                        {image3 && (
                            <img
                                src={image3}
                                alt='product photo_3'
                                onClick={() => setActiveImg(image3)}
                            />
                        )}
                        {image4 && (
                            <img
                                src={image4}
                                alt='product photo_4'
                                onClick={() => setActiveImg(image4)}
                            />
                        )}
                    </div>

                    <div className='img-container'>
                        <img
                            id='imageBox'
                            src={process.env.PUBLIC_URL + `${activeImg}`}
                            alt='Product'
                        />
                    </div>
                </div>

                <div className='product__info'>
                    <div className='product__description'>
                        <h1>{productName}</h1>
                        <p>{productPrice}$</p>
                    </div>
                    <form>
                        <div className='size__select'>
                            <p>Size</p>
                            {SELECT_SIZE}
                        </div>
                    </form>
                    <div className='quantity__selector'>
                        <p>Quantity</p>
                        <input
                            onChange={handleQuantityChange}
                            type='number'
                            placeholder='1'
                            min={1}
                            max={99}
                            value={itemQuantity}
                        />
                    </div>
                    <button
                        key={link}
                        className='product__button'
                        onClick={() => {
                            //setItemPrice(productPrice);
                            //setItemName(productName);
                            addProductToBag({
                                name: productName,
                                price: productPrice,
                                link: link,
                                photo: image1,
                            });
                            resetSizeInputs();
                        }}
                    >
                        ADD TO BAG
                    </button>

                    <ol>
                        {liElements.map((item, index) => (
                            <li
                                className={
                                    activeDetail === item.id ? 'active' : ''
                                }
                                onClick={() => {
                                    setActiveDetail(item.id);
                                    setActiveElement(index + 1);
                                }}
                            >
                                {item.text}
                            </li>
                        ))}
                    </ol>
                    {activeElement === 1 && (
                        <p className='product__info__paragraph'>
                            {productInfo
                                ? productInfo
                                : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.'}
                        </p>
                    )}
                    {activeElement === 2 && (
                        <div className='size__guide'>
                            <p>
                                <span>Fit: </span>This garment fits true to
                                size.
                            </p>
                            <p>
                                <span>Waist: </span>
                                Fitted - stretchy fabric allows custom fit.
                            </p>
                            <p>
                                <span>Bust: </span>Great for any cup size.
                            </p>
                            <p>
                                <span>Hip: </span>
                                Fitted - stretchy fabric allows room for hips.
                            </p>
                            <p>
                                <span>Fabric: </span>
                                Fabric is very stretchy.
                            </p>
                        </div>
                    )}
                    {activeElement === 3 && <h3>Details</h3>}
                    {activeElement === 4 && <h3>Delivery Info</h3>}
                </div>
            </div>

            <Footer />
        </>
    );
}

export default ProductPage;
